import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { TextLoca } from "../../generic/text/TextLoca";
import { FoundEditDescription } from "./FoundEditDescription";
import { FoundEditName } from "./FoundEditName";
export var FoundEditNameAndDescription = function (_a) {
    var coopName = _a.coopName, setCoopName = _a.setCoopName, coopDescription = _a.coopDescription, setCoopDescription = _a.setCoopDescription, coopErrorLoca = _a.coopErrorLoca, coop = _a.coop, charLimit = _a.charLimit, onSubmit = _a.onSubmit;
    return (React.createElement("div", { className: "flex flex-stacked" },
        React.createElement("div", { className: "found-name-description" },
            React.createElement(FoundEditName, { coop: coop, coopName: coopName, setCoopName: setCoopName, onSubmit: onSubmit }),
            React.createElement(FoundEditDescription, { coopDescription: coopDescription, setCoopDescription: setCoopDescription, charLimit: charLimit, onSubmit: onSubmit }),
            coopErrorLoca && React.createElement(TextLoca, { className: IdStyles.TextError, id: coopErrorLoca }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/found-edit/FoundEditNameAndDescription.tsx
// module id = 2583
// module chunks = 3